__turbopack_context__.v({
  "albyChatbotButton": "Layout-module-scss-module__lu5FoW__albyChatbotButton",
  "previewBar": "Layout-module-scss-module__lu5FoW__previewBar",
  "previewBarInner": "Layout-module-scss-module__lu5FoW__previewBarInner",
  "sideBarStyles": "Layout-module-scss-module__lu5FoW__sideBarStyles",
  "sideBarStylesCart": "Layout-module-scss-module__lu5FoW__sideBarStylesCart",
});
